import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { GlobalSpinner, showSuccessAlert, showErrorAlert } from "../../../../../global/globalFunctions";
import { AddWarehouseApi } from "./Warehouse.action";
import { getRestaurantData } from "../AddResturant/Resturant.action";
import { setHeading } from "../../../accounts/account.actions";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import _ from "lodash";
import Select from "react-select";


const AddWarehouse = (props) => {
  const [businessName, setBusinessName] = useState();
  const [location, setLocation] = useState();
  const [city, setCity] = useState();
  const [zipCode, setZipCode] = useState();
  const [state, setSate] = useState();
  const [country, setCountry] = useState();
  const [contact, setContact] = useState();
  const [description, setDescription] = useState();
  const [manager, setManager] = useState();
  const [retaurantId, setRestaurantId] = useState();
  const [restaurantName, setRestaurantName] = useState();


  function SaveWareHouse() {
    props.AddWarehouseApi({
      businessName: businessName,
      location: location,
      city: city,
      zipCode: zipCode,
      state: state,
      country: country,
      contact: contact,
      description: description,
      manager: manager,
      retaurantId: retaurantId,
    },
      showSuccessAlert,
      showErrorAlert,
    );
    setBusinessName("");
    setLocation("");
    setCity("");
    setZipCode("");
    setSate("");
    setCountry("");
    setContact("");
    setDescription("");
    setManager("");
    setRestaurantName("")
  }

  const handleChangeRestaurant = (selectedOption) => {
    setRestaurantId(selectedOption.value);
    setRestaurantName(selectedOption.label);
  };
  const getRetaurantList = props.restaurantDataList?.length ? props.restaurantDataList.map(x => ({
    value: x._id,
    label: x.restaurantName,
  })) : [];

  useEffect(() => {
    props.getRestaurantData();
    props.setHeading("New Businnes Location");
  }, []);

  return (
    <>
      {props.isAddingWarehouse || props.isFetchingRestaurant ? (
        <GlobalSpinner />
      ) : (
        <Container fluid>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Select Company *</b></Form.Label>
                <Select
                  value={{ label: restaurantName }}
                  placeholder="Select Company"
                  onChange={handleChangeRestaurant}
                  options={getRetaurantList}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Store Location *</b> </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Store Location"
                  onMouseLeave={(e) => setBusinessName(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>City </b> </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="City"
                  onMouseLeave={(e) => setCity(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>ZipCode </b> </Form.Label>
                <Form.Control
                  type="number"
                  placeholder="ZipCode"
                  onMouseLeave={(e) => setZipCode(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>State </b></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="State"
                  onMouseLeave={(e) => setSate(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label> <b>Country </b></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Country"
                  onMouseLeave={(e) => setCountry(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Contact Number </b></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Contact Number"
                  onMouseLeave={(e) => setContact(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Description </b> </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Description"
                  onMouseLeave={(e) => setDescription(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Manager Name </b> </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Manager Name"
                  onMouseLeave={(e) => setManager(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Location</b></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Location"
                  onMouseLeave={(e) => setLocation(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="sendDiv">
            {_.isEmpty(businessName) || _.isEmpty(restaurantName) ? (
              <Button variant="contained" endIcon={<SendIcon />} size="large" disabled>SAVE </Button>
            ) : (
              <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={SaveWareHouse}> SAVE</Button>
            )}
          </div>

        </Container>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    AddWarehouseApi: (data, showSuccessAlert, showErrorAlert) => dispatch(AddWarehouseApi(data, showSuccessAlert, showErrorAlert)),
    getRestaurantData: () => dispatch(getRestaurantData()),
    setHeading: (data) => dispatch(setHeading(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  isAddingWarehouse: state.WarehouseReducer.isAddingWarehouse,
  isFetchingRestaurant: state.ResturantReducer.isFetchingRestaurant,
  restaurantDataList: state.ResturantReducer.restaurantDataList,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddWarehouse);
